module.exports = __webpack_public_path__ + "static/img/three.07c80827.png";